import { map as rxjsmap } from 'rxjs';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

import { SKIP_ERROR_TOAST } from 'src/app/shared/http-context-tokens';

import { environment } from 'src/environments/environment';
import { BaseServices } from 'src/app/kuba/kuba.services';
import {
  HttpClient,
  HttpHeaderResponse,
  HttpContext
} from '@angular/common/http';
import { SaveUsers } from '../models/user';

@Injectable()
export class UserService {
  _employeeContactUser: Observable<any> = null!;
  constructor(private http: HttpClient) {}
  clearCachedUserList() {
    this._employeeContactUser = null!;
  }
  getUser(id: number) {
    return this.http
      .get(environment.BASE_URL + '/project/ContactLookup/' + id)
      .pipe(rxjsmap((result: any) => result));
  }
  getDeviationCreatedByUsers() {
    return this.http
      .get<any>(
        environment.BASE_URL + '/createdbyusers/' + BaseServices.BusinessId
      )
      .pipe(rxjsmap(result => result));
  }

  /**
   * get assigned user
   * @param appId {number}
   * @param businessId {number}
   */
  getAssignedUsers(appId: number, businessId: number) {
    return this.http
      .get<any[]>(`${environment.BASE_URL}/users/${appId}/${businessId}`)
      .pipe(rxjsmap(result => result));
  }

  updateLanguage(langId: number) {
    return this.http
      .get(environment.BASE_URL + '/user/modify/language/' + langId)
      .pipe(
        rxjsmap(result => {
          return result;
        })
      );
  }

  getUserProfile() {
    return this.http
      .get<HttpHeaderResponse>(environment.BASE_URL + '/user/profile')
      .pipe(
        rxjsmap((response: HttpHeaderResponse) => {
          return response;
        })
      );
  }

  getUsersById(id: number) {
    return this.http.get<any[]>(environment.BASE_URL + '/user/' + id).pipe(
      rxjsmap((response: any) => {
        return response;
      })
    );
  }

  updateUser(id: number, data: any, handleErrors = false) {
    return this.http
      .put<HttpHeaderResponse>(environment.BASE_URL + '/user/' + id, data, {
        context: new HttpContext().set(SKIP_ERROR_TOAST, handleErrors)
      })
      .pipe(
        rxjsmap((response: HttpHeaderResponse) => {
          return response;
        })
      );
  }

  getLanguages() {
    return this.http
      .get(environment.BASE_URL + '/master/languages')
      .pipe(rxjsmap(result => result));
  }

  getRoles() {
    return this.http
      .get<HttpHeaderResponse>(environment.BASE_URL + '/master/roles')
      .pipe(
        rxjsmap((response: HttpHeaderResponse) => {
          return response;
        })
      );
  }

  addusers(data: any, handleErrors = false) {
    return this.http
      .post<HttpHeaderResponse>(environment.BASE_URL + '/user', data, {
        context: new HttpContext().set(SKIP_ERROR_TOAST, handleErrors)
      })
      .pipe(
        rxjsmap((response: HttpHeaderResponse) => {
          return response;
        })
      );
  }

  /**
   * Creates a new user and sends a SMS with login information
   * @param userDetails User to create
   * @param handleErrors Error handling logic
   * @returns Created user if the creation is successful
   */
  addUserAndSendSMS(userDetails: SaveUsers, handleErrors = false) {
    return this.http
      .post(
        environment.BASE_URL +
          '/save-user-sendsms/' +
          BaseServices.userLanguageId,
        userDetails,
        { context: new HttpContext().set(SKIP_ERROR_TOAST, handleErrors) }
      )
      .pipe(rxjsmap(result => result));
  }

  getUsersByBusiness(businessId: number) {
    return this.http
      .get<any>(environment.BASE_URL + '/userbybusiness/' + businessId)
      .pipe(rxjsmap(result => result));
  }

  /**
   * get employees/contacts with userid
   * @param businessId {number}
   */
  getEmployeeContactUsers(businessId: number) {
    return this.http
      .get<any>(environment.BASE_URL + '/employeecontactusers/' + businessId)
      .pipe(rxjsmap(result => result));
  }

  /**
   * get employees/contacts for portal level
   * @param portalId {number}
   */
  getEmployeeContactUsersPortal(portalId: number) {
    return this.http
      .get<any>(
        environment.BASE_URL + '/employeecontactusers/portal/' + portalId
      )
      .pipe(rxjsmap(result => result));
  }

  getEmployeeOnly(businessId: number) {
    return this.http
      .get<any>(environment.BASE_URL + '/employeeOnly/' + businessId)
      .pipe(rxjsmap(result => result));
  }

  /**
   * get employees/contacts subscription user with userid
   * @param businessId {number}
   */
  getEmployeeContactSubscriptionUsers(businessId: number) {
    return this.http
      .get<any>(
        environment.BASE_URL + '/employeecontactsubscription/' + businessId
      )
      .pipe(rxjsmap(result => result));
  }

  getUserExits(featureId: number, featureKey: number) {
    return this.http
      .get<HttpHeaderResponse>(
        `${environment.BASE_URL}/userexits/${featureId}/${featureKey}`
      )
      .pipe(
        rxjsmap((response: HttpHeaderResponse) => {
          return response;
        })
      );
  }
}
